import ghgStyles from "./GhgDashboard.module.scss";
import GhgTableScope from "./GhgTableScope";
import { IGetGhg, scopes } from "./types";

export default function GhgTable({ data, loading }: { data?: IGetGhg; loading?: boolean }) {
  return (
    <div className={ghgStyles.ghgTable}>
      {scopes.map((scope) => (
        <GhgTableScope
          scope={scope}
          data={data}
          loading={loading}
        />
      ))}
    </div>
  );
}
